<div class="login-wrap">
  <cigna-alerts [alert]="loginAlert$ | async"></cigna-alerts>
  <cigna-login-message [params]="queryParams$ | async"></cigna-login-message>
  <section>
    <div class="cg-inner-page-wrapper">
      <div class="login-inner cg-margin-bottom-xxl">
        <div>
          <cigna-login-form [params]="queryParams$ | async"></cigna-login-form>
        </div>

        <div class="login-welcome">
          <cigna-card
            (click)="openModal(welcomeModal)"
            [cignaTrackClicks]="[
              'trackEventOther',
              'Learn about Evernorth',
              'ac22397',
              {
                eVar120: 'evernorth-welcome-tile',
                eVar119: 'US1881002'
              }
            ]"
          >
            <div class="evn-text-subhead-3">Welcome to Evernorth</div>
            <div class="cg-margin-top-sm">
              Starting September 1, 2021, Cigna Behavioral Health, Inc. became
              Evernorth Behavioral Health, Inc.
            </div>
            <div class="cg-margin-top-sm">
              <button
                cignaButton="link"
                data-test="learn-more-link"
                type="button"
                style="padding: 0"
              >
                Learn about Evernorth
              </button>
            </div>
          </cigna-card>
        </div>
      </div>
    </div>
  </section>

  <div class="cg-inner-page-wrapper cg-margin-top-xl cg-margin-bottom-lg">
    <cigna-resource-links></cigna-resource-links>
  </div>
</div>

<ng-template #welcomeModal>
  <div
    class="cg-dialog"
    aria-labelledby="header"
    data-test="delete-confirmation-modal"
  >
    <h3 class="cg-dialog__header">
      Welcome to Evernorth<button
        cignaButton="link inline no-underline"
        class="cg-dialog__close_new"
        (click)="dialogRef.close()"
      >
        Close
        <cigna-icon class="cml-close-icon" type="close-thin"></cigna-icon>
      </button>
    </h3>
    <mat-dialog-content>
      <p>
        Starting September 1, 2021, Cigna Behavioral Health, Inc. became
        Evernorth Behavioral Health, Inc. Evernorth is a new brand for Cigna's
        growing, high-performing health services portfolio. Its goal is to
        accelerate the delivery of innovative and flexible solutions to meet the
        diverse needs of health plans, employers, and government organizations.
      </p>
      <p>
        As a result of this change, behavioral providers should start using this
        website to access patient benefit tools and information. Upon entering
        the website, you will continue to see Cigna branding as we work into
        2022 to bring you a unified Evernorth experience.
      </p>
      <p>
        Maintaining our relationship with you remains a top priority. At this
        time, there are no changes to your patients’ behavioral benefits and
        there is no disruption of service. You will continue to operate in a
        business as usual manner. For more information, please see below for
        <a
          [href]="
            '/resourceLibrary/behavioralResources/faq'
              | resourceLink
                : { secure: false, type: 'page', targetApp: 'evernorth' }
              | async
          "
          target="resourcesWindow"
          >frequently asked questions</a
        >
        and other resources.
      </p>
    </mat-dialog-content>
  </div></ng-template
>
